import { parseTemplate } from 'url-template';
import mapPagination from '~/Api/Pagination/mapPagination';
import Pagination from '~/Api/Pagination/Pagination';
import mapProductHistoryEvent from '~/Api/Product/History/mapProductHistoryEvent';
import ProductHistoryEvent from '~/Api/Product/History/ProductHistoryEvent';
import ApiClient from '~/ApiClient';

export interface Result {
	items: ProductHistoryEvent[];
	pagination: Pagination;
}

export default function findUserGroupProductsHistory(
	client: ApiClient,
	userId: string,
	groupId: string,
	page: number,
	perPage: number
): Promise<Result> {
	const url = parseTemplate('users/{userId}/product-groups/{groupId}/products-history{?page,perPage}');

	return client
		.fetch(url.expand({ userId, groupId, page, perPage }))
		.then((response) => response.json())
		.then((response) => ({
			items: response.items.map(mapProductHistoryEvent),
			pagination: mapPagination(response.pagination),
		}));
}
